import { AccessUnlocker } from './access-unlocker.js';
import { ConnectionManager } from './connection-manager.js';
import { DeviceInfoReader } from './device-info-reader.js';
import { isAppDeviceState, OtaManager } from './ota-manager.js';
import { ParamRegistry } from './param-registry.js';
/** Class to manage construction of the coupled services */
export class Pikaparam {
    logger;
    access;
    devInfo;
    conn;
    ota;
    param;
    constructor(logger) {
        this.logger = logger;
        this.conn = new ConnectionManager(this.logger);
        this.ota = new OtaManager(this.conn, this.logger);
        this.access = new AccessUnlocker(this.conn, this.logger, this.ota);
        this.devInfo = new DeviceInfoReader(this.ota, this.logger, this.conn, this.access);
        this.param = new ParamRegistry(this.devInfo, this.logger, this.conn, this.access);
        this.devInfo.setup(this.param);
        this.access.setup(this.param);
        this.ota.setup(this.param);
    }
    /** Convenience function to connect and perform some post-connection tasks */
    async connect(device) {
        // Set up the ConnectionManager, including bringing up Lorax
        await this.conn.connect(device);
        // Connection is now established; check OTA device state
        const otaState = await this.ota.checkDeviceState();
        if (isAppDeviceState(otaState)) {
            // Connected to a device running the application; unlock it
            await this.access.unlock();
            // Access is unlocked, read OTA params that require it
            await this.ota.readUnlockedParams();
            // Read other params managed by the DeviceInfoReader
            await this.devInfo.readInfo();
        }
    }
    /** Clean up all subscriptions/resources held */
    teardown() {
        this.ota.teardown();
        this.access.teardown();
        this.devInfo.teardown();
        this.param.teardown();
        this.conn.teardown();
    }
}
//# sourceMappingURL=pikaparam.js.map